import React, {useEffect, useState} from 'react';
import styled from 'styled-components';

const CustomLogo = ({src}: {src: string}) => {
  const [aspectRatio, setAspectRatio] = useState<number | null>(null);

  useEffect(() => {
    const img = new Image();
    img.src = src;
    img.onload = () => {
      if (img.width > 0 && img.height > 0) setAspectRatio(img.width / img.height);
      img.remove();
    };
  });

  return aspectRatio === null ? null : (
    <Logo style={{aspectRatio, backgroundImage: "url('" + src + "')"}} />
  );
};

const LogoBar = ({showLogos}: {showLogos: true | string[]}) =>
  showLogos === true ? (
    <Container>
      <LogoBMI />
      <LogoBurgenland />
      <LogoLE1420 />
      <LogoLeader />
      <LogoEU className="no-select">
        <span>
          Europäischer Landwirtschaftsfonds für die Entwicklung des ländlichen Raums:
          <br />
          Hier investiert Europa in die ländlichen Gebiete.
        </span>
      </LogoEU>
    </Container>
  ) : showLogos.length === 0 ? null : (
    <Container>
      {showLogos.map(logo => (
        <CustomLogo key={logo} src={logo} />
      ))}
    </Container>
  );
export default LogoBar;

const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-around;
  height: var(--logo-bar-height);
  border-top: 1px solid var(--color-border);
`;

const Logo = styled.div`
  height: calc(0.7 * var(--logo-bar-height));
  background-size: contain;
  background-repeat: no-repeat;

  @media screen and (max-width: 750px) {
    height: calc(0.5 * var(--logo-bar-height));
  }
`;

const LogoEU = styled(Logo)`
  aspect-ratio: 1.5;
  display: inline-block;
  color: black;
  background-image: url('flagOfEurope.svg');
  background-position: right;
  text-align: right;
  font-size: 8px;
  line-height: 9px;

  & span {
    display: none;
  }

  @media screen and (min-width: 880px) {
    min-width: 100px;
    padding-right: 90px;

    & span {
      display: inline;
    }
  }
`;

const LogoBMI = styled(Logo)`
  aspect-ratio: 3.9793;
  background-image: url('logoBMI.svg');
`;

const LogoBurgenland = styled(Logo)`
  aspect-ratio: 2.6846;
  background-image: url('logoBurgenland.jpg');
`;

const LogoLE1420 = styled(Logo)`
  aspect-ratio: 3.7791;
  background-image: url('logoLE1420.svg');
`;

const LogoLeader = styled(Logo)`
  aspect-ratio: 1;
  background-image: url('logoLeader.svg');
`;
